export const POPUP_STATE_VISIBLE = 'POPUP_STATE_VISIBLE';
export const POPUP_STATE_HIDDEN = 'POPUP_STATE_HIDDEN';
export const POPUP_STATE_ANIMATION_IN_PROGRESS =
  'POPUP_STATE_ANIMATION_IN_PROGRESS';
